/**
 * DrawerStatusSlot — the drawer toolbar's Status: the per-campaign push pause
 * (kill switch) and, for a tracker whose own switch holds its optimizer, why.
 * The status reads the FULL hold (a held Tres Commas never says "Pushes
 * active"); the amber chip keeps the notice selector, which leaves the
 * global switch to its own banner. Voluum/Binom: no request, unchanged.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import type { TrackerId } from '@trafficpulse/shared';

import { KillSwitchBanner } from '@/features/flow-optimizer/components';
import { useTrackerHold } from '@/features/trackers/flow-optimizer';

import TrackerHeldNotice from '@/features/flow-optimizer/drawer-shell/TrackerHeldNotice';

export interface DrawerStatusSlotProps {
  provider: TrackerId;
  killSwitch: boolean;
  onToggle: (next: boolean) => void;
  disabled: boolean;
}

const DrawerStatusSlot: FC<DrawerStatusSlotProps> = ({ provider, killSwitch, onToggle, disabled }) => {
  const hold = useTrackerHold(provider);
  return (
    <>
      <KillSwitchBanner
        killSwitch={killSwitch}
        provider={provider}
        onToggle={onToggle}
        disabled={disabled}
        heldReason={hold.reason}
      />
      <TrackerHeldNotice provider={provider} reason={hold.global ? null : hold.reason} />
    </>
  );
};

export default DrawerStatusSlot;
